import React, { useState } from 'react';

import AuthFormContainer from '../../common/components/auth-form-container';
import BannerMessage from '../../common/components/banner-message';
import DangerString from '../../common/components/danger-string';
import ThirdPartyForm from '../../common/components/third-party-form';
import IString from '../../common/components/i-string';
import InviteMessage from '../../common/components/invite-message';
import SSOLoginForm from '../../common/components/sso-login-form';

import * as authMethodUtils from '../../common/util/auth-method-util';
import * as serverUtils from '../../common/util/server-util';

import EmailRegisterForm from './email-register-form';

import * as errors from '../constants/errors';
import RegisterFormContainer from './register-form-container';

const REGISTER = 'register_screen';
const SSO_DEDICATED = 'dedicated_sso_screen';

function SignUpAgreement() {
  return (
    <div className='formish backgroundless bigMarginAbove'>
      <p className='noMarginBelow'>
        <DangerString stringKey='sign_up_agreement' />
      </p>
    </div>
  );
}

function Register() {
  const [error, setError] = useState(serverUtils.getError());
  const ssoInfo = serverUtils.getSSO();
  const screen = ssoInfo ? SSO_DEDICATED : REGISTER;

  const authMethods = serverUtils.getAuthMethods();
  const showAll = authMethodUtils.allowAll(authMethods);
  const showLocal = authMethods[authMethodUtils.LOCAL_AUTH_METHOD];
  const showThirdParty = authMethodUtils.hasThirdPartyAuthMethod(authMethods);

  return (
    <>
      { error && 
        <BannerMessage type='error' className='marginBelow onPage' onClose={() => setError()}>
          { errors.isKnownError(error.error_type) 
            ? <IString stringKey={`errors.${error.error_type}`} />
            : error.error }
        </BannerMessage>
      }
      
      <InviteMessage />

      { screen === REGISTER && 
        <RegisterFormContainer>
          {(showAll || showLocal) &&
            <>
              <EmailRegisterForm />

              {(showAll || showThirdParty) &&
                <div className='center lightText midMarginAbove midMarginBelow'>
                  <IString stringKey='or' />
                </div>
              }
            </>
          }

          {(showAll || showThirdParty) &&
            <div className='formish backgroundless'>
              {authMethodUtils.THIRD_PARTY_AUTH_METHODS.map((authMethod, i) => {
                return (showAll || authMethods[authMethod]) &&
                  <ThirdPartyForm
                    className={i === 0 ? 'noMarginAbove' : 'marginAbove'}
                    key={authMethod}
                    register
                    thirdPartyName={authMethod}
                  />;
              })}
            </div>
          }

          <SignUpAgreement />
        </RegisterFormContainer>
      }

      { screen === SSO_DEDICATED && 
        <AuthFormContainer title={<IString stringKey='general.title.register' />}>
          <SSOLoginForm {...ssoInfo} context='dedicated' />

          <SignUpAgreement />
        </AuthFormContainer>
      }
    </>
  );
}

export default Register;
